<template>

    <div class="row">
        <div class="col-md-2">
            <card class="mainnav-card nav-card">
                <ul class="nav flex-column nav-pills">
                    <li v-for="tab in tabs" :key="tab.route" class="nav-item">
                        <router-link :to="{ name: tab.route }" class="nav-link"
                                     active-class="active" :exact="tab.exact">
                            <fa :icon="tab.icon" fixed-width/>
                            {{ tab.name }}
                        </router-link>
                    </li>
                </ul>
            </card>

            <card v-if="childNavVisible" :title="childNavTitle"
                  class="childnav-card nav-card">
                <ul class="nav flex-column nav-pills">
                    <li v-for="option in childNavOptions" :key="option.route"
                        class="nav-item">
                        <router-link :to="{ name: option.route }"
                                     class="nav-link" active-class="active">
                            <fa :icon="option.icon" fixed-width/>
                            {{ option.name }}
                        </router-link>
                    </li>
                </ul>
            </card>
        </div>

        <div class="col-md-10">
            <transition name="fade" mode="out-in">
                <slot>
                    <router-view/>
                </slot>
            </transition>
        </div>
    </div>

</template>

<script>
    import userauth from '../helpers/userauth';

    export default {
        name: 'Child',

        computed: {
            tabs() {
                if (!userauth.isLoggedIn()) {
                    return [];
                }

                var ret = [
                    {
                        icon: 'th-large',
                        name: 'Dashboard',
                        route: 'dashboard',
                        exact: true
                    },
                    {
                        icon: 'building',
                        name: 'Buildings',
                        route: 'buildings',
                        exact: false
                    }
                ];

                if (userauth.isSuperAdmin()) {
                    ret.push({
                        icon: 'user',
                        name: 'Users',
                        route: 'users',
                        exact: false
                    });
                }

                if (userauth.isOrgManager()) {
                    ret.push({
                        icon: 'university',
                        name: 'Organisations',
                        route: 'orgs',
                        exact: false
                    });
                }

                return ret;
            },

            childNavVisible() {
                return this.$store.state.childnav.visible;
            },

            childNavTitle() {
                return this.$store.state.childnav.title;
            },

            childNavOptions() {
                return this.$store.state.childnav.options;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Child.vue